import { Stack, Text } from '@chakra-ui/react';
import AboutThisLens from './about-this-lens.component';

import InsightMetadata from './insight-metadata.component';
import { useInfinitePreviousInsights } from '@util/hooks';
import InsightList from './insight-list.component';

export default function NewInsightRightRail({ lens, insight }) {
  const { previousInsightsRes, isFetching } = useInfinitePreviousInsights(insight);
  const previousInsights = previousInsightsRes?.pages?.flatMap((page) => page?.data || []);
  return (
    <Stack
      gap={8}
      p={8}
      w='full'
    >
      <Stack gap={4}>
        <Text
          mt={2}
          color='surface.onSurfaceVariant'
          variant='label-caps-600-lg'
        >
          About This Lens
        </Text>
        <AboutThisLens lens={lens} />
      </Stack>

      <InsightMetadata
        lens={lens}
        insight={insight}
      />

      <Stack
        py={6}
        gap={10}
      >
        <InsightList
          insights={previousInsights}
          isLoading={isFetching}
          noResultsText='No Previous Insights'
        />
      </Stack>
    </Stack>
  );
}
